<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit"><a id="page_iii"></a>THE BATTLE OF BRITAIN</h1>
<h1 class="tit0">ON THE</h1>
<h1 class="tit1">BIG SCREEN</h1>
<p class="tsub"><span class="bold">‘The Finest Hour’ Through British Cinema</span></p>
<p class="aut"><span class="bold">Dilip Sarkar MBE, FRHistS</span></p>
<div class="img_container">
<img alt="Images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?013809c2